export default "__VITE_ASSET__35395ef1__"